// extracted by mini-css-extract-plugin
export default {"container":"Connection_container__O-PPM","error":"Connection_error__UbaMY","friend-list":"Connection_friend-list__Gjq4m","friend-card":"Connection_friend-card__7vu-p"};